import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SeatType } from '../../../../enums/seat-type.enum';
import { CreateSeatDto } from '../../../../dtos/create-show.dto';

@Component({
  selector: 'app-show-seat-step',
  templateUrl: './show-seat-step.component.html',
  styleUrls: ['./show-seat-step.component.scss']
})
export class ShowSeatStepComponent implements OnInit {
  @Input() seats: CreateSeatDto[][] = [];
  @Input() seatSelect: Array<{ index: number, seat: CreateSeatDto }> = [];
  @Input() index: number | undefined;
  @Input() disabled: boolean | undefined;
  @Input() cleanForm: boolean | undefined;
  @Output() onSelectSeat = new EventEmitter<CreateSeatDto>();
  @Output() onRemoveSeat = new EventEmitter<number>();
  @Output() onSelectTypeSeat = new EventEmitter<{ index: number, type: string }>();

  typesSelect: Array<{ value: string, label: string }> = Array(
    { value: SeatType.UNAVAILABLE, label: 'Indisponínel' },
    { value: SeatType.REDUCED_MOBILITY, label: 'Mobilidade Reduzida' },
    { value: SeatType.OBESITY, label: 'Obesidade' },
    { value: SeatType.OCUPIED, label: 'Ocupado' },
    { value: SeatType.HIDDEN, label: 'Vazio' },
  );

  stepForm: FormGroup = this.fb.group({
    seat: new FormControl({ value: '', disabled: false }),
    type: new FormControl({ value: '', disabled: false })
  })

  constructor(
    private readonly fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    if (this.seatSelect && this.seatSelect.length > this.index!) {
      this.stepForm.controls['type'].setValue(this.seatSelect[this.index!].seat.type);
      this.stepForm.controls['seat'].setValue(this.seatSelect[this.index!].seat);
    }
    if (this.disabled){
      this.stepForm.disable();
    }
    if (this.cleanForm){
      this.stepForm =  this.fb.group({
        seat: new FormControl({ value: '', disabled: false }),
        type: new FormControl({ value: '', disabled: false })
      })
    }
  }

  onSelect(seat: CreateSeatDto, event: any) {
    if (event.isUserInput) {
      this.onSelectSeat.emit(seat);
    }
  }

  onSelectType(index: number, type: string, event: any) {
    if (event.isUserInput) {
      this.onSelectTypeSeat.emit({ index: index, type: type });
    }
  }

  onRemove(index: number) {
    this.onRemoveSeat.emit(index);
  }
}
